import application from '../../config/app/config';

export const ProviderServiceEndpoints = {
  getFavouriteBanks: (url: string) => {
    return `${url}/favourites`;
  },
  getBank: (url: string, providerId: number) => {
    return `${url}/provider/${providerId}`;
  },
  getBanks: (url: string, bankCode: string) => {
    return `${url}/search/bank-code/${bankCode}`;
  },
  searchBanks: (url: string) => {
    return `${url}/search`;
  },
  countryCodes: (url: string) => {
    return `${url}/countries`;
  }
};

export const GatewayServiceEndpoints = {
  createConsentConnection: (url: string, consentId: string) => {
    return `${url}/consents/${consentId}/connection`;
  },
  reauthenticateConsentConnection: (url: string, consentId: string) => {
    return `${url}/consents/${consentId}/connection/reauthenticate`;
  },
  reconfirmConsentConnection: (url: string, consentId: string) => {
    return `${url}/consents/${consentId}/connection/reconfirm`;
  },
  connectionSummary: (url: string) => {
    return `${url}/consent/connection/summary`;
  },
  paymentAccountConfirmation: (url: string) => {
    return `${url}/consent/connection/payment-confirmation`;
  },
  connectionDetails: (url: string) => {
    return `${url}/consent/connection/details`;
  }
};

export const ConsentServiceEndpoints = {
  consentBaseUrl: (url: string) => {
    return url;
  },
  postConsent: (url: string) => {
    return `${url}`;
  },
  getConsent: (url: string, consentId: string) => {
    return `${url}/${consentId}`;
  },
  revokeConsent: (url: string, consentId: string) => {
    return `${url}/${consentId}/revoke`;
  }
};

export const InsightsApiServiceEndpoints = {
  insightsApiBaseUrl: (url: string) => {
    return url;
  },
  savePaymentConfirmationData: (url: string) => {
    return `${url}/stored-data/v1/payment-account-confirmation/`;
  }
};

export const ConnectApiEndpoints = {
  createStoredUser(url: string) {
    return `${url}/users/v1/invitation`;
  },
  createTuUser(url: string) {
    return `${url}/users/v1`;
  },
  sendOtp(url: string) {
    return `${url}/otp/v1/send`;
  },
  validateOtp(url: string) {
    return `${url}/otp/v1/validate`;
  },
  loqateFind(url: string) {
    return `${url}/address/v1/find`;
  },
  loqateRetrieve(url: string) {
    return `${url}/address/v1/retrieve`;
  },
  createConsent(url: string) {
    return `${url}/consents/v1`;
  },
  getKbaQuestions(url: string) {
    return `${url}/kba/v1/questions/fetch`;
  },
  submitKbaAnswers(url: string) {
    return `${url}/kba/v1/questions/validate`;
  },
  getCreditDataAccounts(url: string) {
    return `${url}/credit-data/v1/accounts`;
  }
};

export const ConfigurationServiceEndpoints = {
  configurationBaseUrl: application.env.CONFIGURATION_API_BASE_URL,
  getTerms: `${application.env.CONFIGURATION_API_BASE_URL}/customer-configuration/{name}/terms`,
  getDiscoveryUrls: (appId: string) => {
    return `${application.env.CONFIGURATION_API_BASE_URL}/application/${appId}/discovery`;
  },
  getSettings: `${application.env.CONFIGURATION_API_BASE_URL}/customer-configuration/{name}/connect-settings`
};
